import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  LeadershipCornerAdminSetting,
  LeadershipCornerAdminSettingsUpdateSettingAction,
  LeadershipCornerAdminSettingsUpdateSettingRejectedAction,
} from '../../domains/leadershipCornerAdminSettings/actions.types';
import { LeadershipCornerLoadAdminSettingsAction } from '../../domains/leadershipCornerAdminSettings/loadActions.types';

import { LeadershipCornerAdminSettingsLifecycle } from './types';

const initialState: LeadershipCornerAdminSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const updateFulfilledLeadershipCornerAdminSettingWithNewValue = (
  state: LeadershipCornerAdminSettingsLifecycle,
  payload: LeadershipCornerAdminSetting
) => ({
  ...state,
  fulfilled: { ...state.fulfilled, [payload.settingProp]: payload.settingValue },
});

const updateFulfilledLeadershipCornerAdminSettingWithPreviousValue = (
  state: LeadershipCornerAdminSettingsLifecycle,
  payload: LeadershipCornerAdminSettingsUpdateSettingRejectedAction['payload']
) => ({
  ...state,
  fulfilled: { ...state.fulfilled, [payload.setting.settingProp]: payload.prevSettingValue },
});

const reducer: Reducer<
  LeadershipCornerAdminSettingsLifecycle,
  LeadershipCornerAdminSettingsUpdateSettingAction | LeadershipCornerLoadAdminSettingsAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'LEADERSHIP_CORNER_ADMIN_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'LEADERSHIP_CORNER_ADMIN_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'LEADERSHIP_CORNER_ADMIN_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'LEADERSHIP_CORNER_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_PENDING':
      return updateFulfilledLeadershipCornerAdminSettingWithNewValue(state, action.payload);
    case 'LEADERSHIP_CORNER_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_REJECTED':
      return updateFulfilledLeadershipCornerAdminSettingWithPreviousValue(state, action.payload);
    case 'LEADERSHIP_CORNER_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_FULFILLED':
      return updateFulfilledLeadershipCornerAdminSettingWithNewValue(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
